/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable camelcase */

import moment from 'moment';

import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import K from 'utils/functions/k.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import { ColumnsOrder } from 'stocks/consts';

const L = logger('stocks/utils');

export function checkIfFilterGroupIsActive(filter) {
  return Object.keys(filter).some((key) => filter[key]);
}

export function checkIfFiltersAreActive(filters) {
  for (const filter of filters) {
    if (checkIfFilterGroupIsActive(filter.values)) {
      return true;
    }
  }
  return false;
}

export function applyFilters(data, filters) {
  // check if we have at least 1 active filter
  const areFiltersActive = checkIfFiltersAreActive(filters);

  // we didn't find any filters, so we just return the default data
  if (!areFiltersActive) {
    L.debug('applyFilters()', 'areFiltersActive:', areFiltersActive);
    return data;
  }

  let parentFilterFound = false;
  return filters.reduce((list, item) => {
    // we check if we have found the parent filter
    // if we haven't then we are still searching for it and if we ever find a filter
    // that is actually toggled on, we will start pushing elements in the array that would be shown
    if (!parentFilterFound) {
      Object.keys(item.values).forEach((key) => {
        if (item.values[key]) {
          parentFilterFound = true;
          data.forEach((e) => {
            const k = e[item.field] || getAnyOrVoid(['manufacturer_product', item.field], e);
            if (key === k && list.indexOf(e) === -1) {
              list.push(e);
            }
          });
        }
      });
      return list;
    }

    // if we however did find a parent filter then we must apply all subsequent filters
    // on the main set that we have created while finding the parent filter
    // so from now on we will REMOVE from the array that we created during parent filter execution
    const keys = Object.keys(item.values);

    // Still we need to check if actually that group of filters is indeed toggled on
    // A group of filters is considered toggled on if at least 1 filter in it works
    if (keys.some((key) => item.values[key])) {
      return list.filter((e) => {
        const k = e[item.field] || (e.manufacturer_product ? e.manufacturer_product[item.field] : '');
        return keys.some((key) => item.values[key] && key === k);
      });
    }
    return list;
  }, []);
}

export function sortStockList(newSortItemData, newSortList, sortOptionString) {
  let sortedResult = newSortList;
  let sortItem = sortOptionString;
  if (sortOptionString === '') {
    // eslint-disable-next-line prefer-destructuring
    sortItem = newSortItemData[0];
  }
  if (!sortItem) {
    sortItem = 'brand';
  }
  if (newSortItemData.indexOf(sortItem) > -1) {
    if (newSortItemData.filter((c) => c === sortItem).length > 1) {
      if (sortItem === 'brand') {
        sortedResult = newSortList.sort((a, b) => (b.brand ? b.brand.localeCompare(a.brand) : 0));
      }
      if (sortItem === 'sub-brand') {
        sortedResult = newSortList.sort((a, b) => (b.sub_brand ? b.sub_brand.localeCompare(a.sub_brand) : 0));
      }
      if (sortItem === 'category') {
        sortedResult = newSortList.sort((a, b) => (b.category_name ? b.category_name.localeCompare(a.category_name) : 0));
      }
      if (sortItem === 'title') {
        sortedResult = newSortList.sort((a, b) => (b.title ? b.title.localeCompare(a.title) : 0));
      }
      if (sortItem === 'quantity') {
        sortedResult = newSortList.sort((a, b) => a.units_in_stock - b.units_in_stock);
      }
      if (sortItem === 'sold') {
        sortedResult = newSortList.sort((a, b) => (b.usedSoldInRangeData && a.usedSoldInRangeData ? a.usedSoldInRangeData.sold - b.usedSoldInRangeData.sold : 0));
      }
      if (sortItem === 'used') {
        sortedResult = newSortList.sort((a, b) => (b.usedSoldInRangeData && a.usedSoldInRangeData ? a.usedSoldInRangeData.used - b.usedSoldInRangeData.used : 0));
      }
      if (sortItem === 'used/soldLast30days') {
        sortedResult = newSortList.sort((a, b) => a.sold_last_30_days + a.used_last_30_days - (b.sold_last_30_days + b.used_last_30_days));
      }
      if (sortItem === 'dateOfLastChange') {
        sortedResult = newSortList.sort((a, b) => (a.latest_change && b.latest_change ? moment(a.latest_change.timestamp) - moment(b.latest_change.timestamp) : 0));
      }
      if (sortItem === 'amountLastChange') {
        sortedResult = newSortList.sort((a, b) => (a.latest_change && b.latest_change ? a.latest_change.amount - b.latest_change.amount : 0));
      }
      if (sortItem === 'typeOfLastChange') {
        sortedResult = newSortList.sort((a, b) => (a.latest_change && b.latest_change && a.latest_change.type && b.latest_change.type ? a.latest_change.type.localeCompare(b.latest_change.type) : 0));
      }
      if (sortItem === 'costOfUsed') {
        sortedResult = newSortList.sort(
          (a, b) => (a.usedSoldInRangeData ? a.usedSoldInRangeData.used : 0) * parseFloat(a.cost_price) - (b.usedSoldInRangeData ? b.usedSoldInRangeData.used : 0) * parseFloat(b.cost_price),
        );
      }
      if (sortItem === 'costOfSold') {
        sortedResult = newSortList.sort(
          (a, b) => (a.usedSoldInRangeData ? a.usedSoldInRangeData.sold : 0) * parseFloat(a.cost_price) - (b.usedSoldInRangeData ? b.usedSoldInRangeData.sold : 0) * parseFloat(b.cost_price),
        );
      }
    } else {
      // Sort desc and put it in the string
      if (sortItem === 'brand') {
        sortedResult = newSortList.sort((a, b) => (a.brand ? a.brand.localeCompare(b.brand) : 0));
      }
      if (sortItem === 'sub-brand') {
        sortedResult = newSortList.sort((a, b) => (a.sub_brand ? a.sub_brand.localeCompare(b.sub_brand) : 0));
      }
      if (sortItem === 'category') {
        sortedResult = newSortList.sort((a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 0));
      }
      if (sortItem === 'title') {
        sortedResult = newSortList.sort((a, b) => a.title.localeCompare(b.title));
      }
      if (sortItem === 'quantity') {
        sortedResult = newSortList.sort((a, b) => (b.usedSoldInRangeData && a.usedSoldInRangeData ? b.units_in_stock - a.units_in_stock : 0));
      }
      if (sortItem === 'sold') {
        sortedResult = newSortList.sort((a, b) => (b.usedSoldInRangeData && a.usedSoldInRangeData ? b.usedSoldInRangeData.sold - a.usedSoldInRangeData.sold : 0));
      }
      if (sortItem === 'used') {
        sortedResult = newSortList.sort((a, b) => (b.usedSoldInRangeData && a.usedSoldInRangeData ? b.usedSoldInRangeData.used - a.usedSoldInRangeData.used : 0));
      }
      if (sortItem === 'costOfUsed') {
        sortedResult = newSortList.sort(
          (a, b) => (b.usedSoldInRangeData ? b.usedSoldInRangeData.used : 0) * parseFloat(b.cost_price) - (a.usedSoldInRangeData ? a.usedSoldInRangeData.used : 0) * parseFloat(a.cost_price),
        );
      }
      if (sortItem === 'costOfSold') {
        sortedResult = newSortList.sort(
          (a, b) => (b.usedSoldInRangeData ? b.usedSoldInRangeData.sold : 0) * parseFloat(b.cost_price) - (a.usedSoldInRangeData ? a.usedSoldInRangeData.sold : 0) * parseFloat(a.cost_price),
        );
      }
      if (sortItem === 'used/soldLast30days') {
        sortedResult = newSortList.sort((a, b) => b.sold_last_30_days + b.used_last_30_days - (a.sold_last_30_days + a.used_last_30_days));
      }
      if (sortItem === 'dateOfLastChange') {
        sortedResult = newSortList.sort((a, b) => (a.latest_change && b.latest_change ? moment(b.latest_change.timestamp) - moment(a.latest_change.timestamp) : 0));
      }
      if (sortItem === 'amountLastChange') {
        sortedResult = newSortList.sort((a, b) => (a.latest_change && b.latest_change ? b.latest_change.amount - a.latest_change.amount : 0));
      }
      if (sortItem === 'typeOfLastChange') {
        sortedResult = newSortList.sort((a, b) => (a.latest_change && b.latest_change && a.latest_change.type && b.latest_change.type ? b.latest_change.type.localeCompare(a.latest_change.type) : 0));
      }
    }
  }
  return sortedResult;
}

export function mapStocks(data) {
  const retValue = {};
  data.forEach((el) => {
    const brand = el.getBrand();
    const subBrand = el.getFamily();
    const category_name = el.getCategory();
    if (!retValue[brand]) {
      retValue[brand] = {};
    }
    if (!retValue[brand][subBrand]) {
      retValue[brand][subBrand] = [];
    }
    if (!retValue[brand][subBrand][category_name]) {
      retValue[brand][subBrand][category_name] = [];
    }
    retValue[brand][subBrand][category_name].push(el);
  });
  return retValue;
}

export function mapStockOrders(data) {
  const retValue = {};
  data.forEach((el) => {
    const { brand } = el;
    const subBrand = el.sub_brand;
    const { category_name } = el;
    if (!retValue[brand]) {
      retValue[brand] = {};
    }
    if (!retValue[brand][subBrand]) {
      retValue[brand][subBrand] = [];
    }
    if (!retValue[brand][subBrand][category_name]) {
      retValue[brand][subBrand][category_name] = [];
    }
    retValue[brand][subBrand][category_name].push(el);
  });
  return retValue;
}

export function mapOrderProducts(data) {
  const retValue = {};
  data.forEach((el) => {
    const brand = el.product.brand_name;
    const subBrand = el.product.sub_brand_name;
    const category = el.product.category_name;

    if (!retValue[brand]) {
      retValue[brand] = {};
    }
    if (!retValue[brand][subBrand]) {
      retValue[brand][subBrand] = [];
    }
    if (!retValue[brand][subBrand][category]) {
      retValue[brand][subBrand][category] = [];
    }
    retValue[brand][subBrand][category].push(el);
  });

  return retValue;
}

export function initFilters(data, currentFilters) {
  let filterCategories;

  if (currentFilters && currentFilters.length > 0) {
    filterCategories = currentFilters;
  } else {
    filterCategories = [
      { field: 'brand', values: {}, parents: {}, shownTitle: 'Brand' },
      { field: 'sub_brand', values: {}, parents: {}, shownTitle: 'Sub brand' },
      { field: 'category_name', values: {}, parents: {}, shownTitle: 'Category' },
    ];
  }

  // those are needed to delete the filters that are no longer available
  const usedBrands = [];
  const usedFamilies = [];
  const usedCategories = [];

  data.forEach((stock) => {
    const brand = stock.getBrand();
    usedBrands.push(brand);
    const family = stock.getFamily();
    usedFamilies.push(family);
    const category = stock.getCategory();
    usedCategories.push(category);

    // a.k.a. is undefined
    if (!filterCategories[0].values[brand] && filterCategories[0].values[brand] !== false) {
      filterCategories[0].values[brand] = true;
      filterCategories[0].parents[brand] = { parentsPointer: null, parentKeys: [] };
    } else {
      // clear filter
      filterCategories[0].values[brand] = true;
    }
    if (!filterCategories[1].values[family]) {
      filterCategories[1].values[family] = true;
    }
    if (filterCategories[1].parents[family]) {
      if (filterCategories[1].parents[family].parentKeys.indexOf(brand) < 0) {
        filterCategories[1].parents[family].parentKeys.push(brand);
      }
    } else {
      filterCategories[1].parents[family] = { parentsPointer: filterCategories[0].values, parentKeys: [brand] };
    }
    if (!filterCategories[2].values[category] && filterCategories[1].values[category] !== false) {
      filterCategories[2].values[category] = true;

      if (filterCategories[2].parents[category]) {
        filterCategories[2].parents[category].parentKeys.push(family);
      } else {
        filterCategories[2].parents[category] = { parentsPointer: filterCategories[1].values, parentKeys: [family] };
      }
    }
  });

  // delete the no longer available filters
  Object.keys(filterCategories[0].values).forEach((key) => {
    if (usedBrands.indexOf(key) === -1) {
      delete filterCategories[0].values[key];
    }
  });

  Object.keys(filterCategories[1].values).forEach((key) => {
    if (usedFamilies.indexOf(key) === -1) {
      delete filterCategories[1].values[key];
    }
  });

  Object.keys(filterCategories[2].values).forEach((key) => {
    if (usedCategories.indexOf(key) === -1) {
      delete filterCategories[2].values[key];
    }
  });
  return filterCategories;
}

export function toggleFilter(filters, filter, valueToToggle, setValue) {
  const newFilters = filters.slice(0);
  for (let i = 0; i < newFilters.length; i++) {
    const currentFilter = newFilters[i];
    if (
      currentFilter.field === filter.field &&
      // checking if it is not undefined
      (currentFilter.values[valueToToggle] || currentFilter.values[valueToToggle] === false)
    ) {
      if (setValue) {
        currentFilter.values[valueToToggle] = setValue;
      } else {
        currentFilter.values[valueToToggle] = !currentFilter.values[valueToToggle];
      }
    }
  }
  return newFilters;
}

export const upgradeStock = (stock) => {
  const s = fromAnyToString;

  const sp = asObject(stock);
  const mp = asObject(sp.manufacturer_product);

  // NOTE: filters depend on same prop being in both el and el.manufacturer_product
  const category = s(sp.category_name) || s(mp.category) || s(mp.category_name);
  const name = s(sp.title) || s(mp.name);
  const brand = s(sp.brand) || s(mp.brand);
  const sub = s(sp.sub_brand) || s(mp.sub_brand);

  return { ...stock, getName: K(name), getBrand: K(brand), getFamily: K(sub), getCategory: K(category) };
};

export function calculateCurrentLayout(pathName) {
  if (pathName.indexOf('manager') > -1) {
    return ColumnsOrder.ManagerLayoutColumnsOrder;
  } else if (pathName.indexOf('holdingValue') > -1) {
    return ColumnsOrder.StockHoldingColumnsOrder;
  } else if (pathName.indexOf('usedSoldOverDateRange') > -1) {
    return ColumnsOrder.UsedSoldOverDateRange;
  } else if (pathName.indexOf('lastStockMovement') > -1) {
    return ColumnsOrder.LastStockMovement;
  }

  return [];
}
